import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Quasar from 'quasar/src/vue-plugin.js';import Notify from 'quasar/src/plugins/Notify.js';import Dialog from 'quasar/src/plugins/Dialog.js';
import quasarUserConfig from './quasar-user-config'
import 'maz-ui/css/main.css'
import MazPhoneNumberInput from 'maz-ui/components/MazPhoneNumberInput'

createApp(App)
    .use(Quasar, { plugins: { Notify, Dialog } }, quasarUserConfig)
    .use(router)
    .component('MazPhoneNumberInput', MazPhoneNumberInput)
    .mount('#app')
